import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=e7948432&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7948432",
  null
  
)

export default component.exports